<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12 mt-4">
        <b-button
          variant="secondary"
          @click.prevent="prevClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>
        <span><b>{{ formatDateDisplayLocal(startofweek) }} -
            {{ formatDateDisplayLocal(endofweek) }}</b></span>
        <b-button
          variant="secondary"
          @click.prevent="nextClick"
          class="ml-3"
        ><i
            class="fas fa-chevron-right text-grey"
            aria-hidden="true"
          ></i></b-button>
      </div>
      <div class="col-md-12 mt-3">
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Sunday']"
          :dow="'Sunday'"
          :date="this.dateOfWeek['Sunday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Monday']"
          :dow="'Monday'"
          :date="this.dateOfWeek['Monday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Tuesday']"
          :dow="'Tuesday'"
          :date="this.dateOfWeek['Tuesday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Wednesday']"
          :dow="'Wednesday'"
          :date="this.dateOfWeek['Wednesday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Thursday']"
          :dow="'Thursday'"
          :date="this.dateOfWeek['Thursday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Friday']"
          :dow="'Friday'"
          :date="this.dateOfWeek['Friday']"
          v-on:class-search="classSearch"
        ></classes-day>
        <classes-day
          :loading="loading"
          :schedulesDow="scheduleSort['Saturday']"
          :dow="'Saturday'"
          :date="this.dateOfWeek['Saturday']"
          v-on:class-search="classSearch"
        ></classes-day>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import ClassesDay from "./ClassesDay.vue";
import { getDateFormat, formatDateDisplay } from "./../js/utils/date.js";
export default {
  components: {
    ClassesDay
  },
  data() {
    return {
      loading: false,
      date_from: null,
      date_to: null,
      schedules: null,
      startofweek: getDateFormat(
        moment()
          .startOf("week")
          .format("YYYY-MM-DD")
      ),
      endofweek: getDateFormat(
        moment()
          .endOf("week")
          .format("YYYY-MM-DD")
      ),
      //startofweek: "2020-05-31",
      //endofweek: "2020-06-06",
      /* dateOfWeek: {
        Monday: null,
        Tuesday: null,
        Wednesday: null,
        Thursday: null,
        Friday: null,
        Saturday: null,
        Sunday: null
      }, */
      scheduleSort: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: []
      },
      cacheClasses: null
    };
  },
  computed: {
    dateOfWeek() {
      return {
        Sunday: moment(this.startofweek).format("YYYY-MM-DD"),
        Monday: moment(this.startofweek)
          .add(1, "d")
          .format("YYYY-MM-DD"),
        Tuesday: moment(this.startofweek)
          .add(2, "d")
          .format("YYYY-MM-DD"),
        Wednesday: moment(this.startofweek)
          .add(3, "d")
          .format("YYYY-MM-DD"),
        Thursday: moment(this.startofweek)
          .add(4, "d")
          .format("YYYY-MM-DD"),
        Friday: moment(this.startofweek)
          .add(5, "d")
          .format("YYYY-MM-DD"),
        Saturday: moment(this.startofweek)
          .add(6, "d")
          .format("YYYY-MM-DD")
      };
    }
  },
  mounted() {
    this.setDateOfWeek();
    this.setCacheClasses();
    this.classSearch();
  },
  methods: {
    setDateOfWeek() {
      this.dateOfWeek["Sunday"] = moment(this.startofweek).format("YYYY-MM-DD");
      this.dateOfWeek["Monday"] = moment(this.startofweek)
        .add(1, "d")
        .format("YYYY-MM-DD");
      this.dateOfWeek["Tuesday"] = moment(this.startofweek)
        .add(2, "d")
        .format("YYYY-MM-DD");
      this.dateOfWeek["Wednesday"] = moment(this.startofweek)
        .add(3, "d")
        .format("YYYY-MM-DD");
      this.dateOfWeek["Thursday"] = moment(this.startofweek)
        .add(4, "d")
        .format("YYYY-MM-DD");
      this.dateOfWeek["Friday"] = moment(this.startofweek)
        .add(5, "d")
        .format("YYYY-MM-DD");
      this.dateOfWeek["Saturday"] = moment(this.startofweek)
        .add(6, "d")
        .format("YYYY-MM-DD");
    },
    prevClick() {
      this.startofweek = getDateFormat(
        moment(this.startofweek)
          .subtract(7, "d")
          .startOf("week")
          .format("YYYY-MM-DD")
      );
      this.endofweek = getDateFormat(
        moment(this.startofweek)
          .add(6, "d")
          .endOf("week")
          .format("YYYY-MM-DD")
      );
      this.setDateOfWeek();
      this.classSearch();
    },
    nextClick() {
      this.startofweek = getDateFormat(
        moment(this.endofweek)
          .add(1, "d")
          .startOf("week")
          .format("YYYY-MM-DD")
      );
      this.endofweek = getDateFormat(
        moment(this.startofweek)
          .add(6, "d")
          .endOf("week")
          .format("YYYY-MM-DD")
      );
      this.setDateOfWeek();
      this.classSearch();
    },
    async classSearch() {
      //console.log(moment().format("DD/MM/YYYY"));
      this.loading = true;
      await axios
        .post("/api/classes/findclass", {
          date_from: this.startofweek,
          date_to: this.endofweek
        })
        .then(response => {
          //console.log(response.data);
          this.resetScheduleSort();
          //this.schedules = response.data;

          for (var i = 0; i < response.data.length; i++) {
            let date_from = moment(response.data[i].start_at);
            let dow = date_from.format("dddd");
            //console.log(this.scheduleSort);
            this.scheduleSort[dow].push(response.data[i]);
          }
          //console.log(this.scheduleSort);
          this.loading = false;
        });
    },
    setCacheClasses() {
      /*  await axios
        .post("/api/classes/findclass", {
          date_from: this.startofweek,
          date_to: this.endofweek
        })
        .then(response => {
          //console.log(response.data);
          this.resetScheduleSort();
          //this.schedules = response.data;

          for (var i = 0; i < response.data.length; i++) {
            let date_from = moment(response.data[i].start_at);
            let dow = date_from.format("dddd");
            //console.log(this.scheduleSort);
            this.scheduleSort[dow].push(response.data[i]);
          }
          //console.log(this.scheduleSort);
          this.loading = false;
        }); */
    },
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    },
    resetScheduleSort() {
      this.scheduleSort["Sunday"] = [];
      this.scheduleSort["Monday"] = [];
      this.scheduleSort["Tuesday"] = [];
      this.scheduleSort["Wednesday"] = [];
      this.scheduleSort["Thursday"] = [];
      this.scheduleSort["Friday"] = [];
      this.scheduleSort["Saturday"] = [];
    }
  }
};
</script>
